import React, {FormEvent, Component} from 'react';
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControlProps,
  Modal,
  Spinner,
  Tooltip,
  Row,
} from "react-bootstrap";
import TooltipButton from './TooltipButton';
import {Link} from 'react-router-dom';

interface SearchFormProps {
  policyNumber: string;
  feinNumber: string;
  isPolicyNumber: boolean;
  isFeinNumber: boolean;
  onSearchSubmit: (term: string) => void;
  onChange: (e: any) => void;
  loading: boolean;
}

interface SearchFormState {
  validated: boolean;
  newPolicy: boolean;
}

class SearchForm extends Component<SearchFormProps, SearchFormState> {
  state: SearchFormState = {validated: false, newPolicy: false};

  handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (this.props.isPolicyNumber) {
      this.props.onSearchSubmit(this.props.policyNumber);
    } else {
      this.props.onSearchSubmit(this.props.feinNumber);
    }
  };

  handleNewPolicy = () => {
    this.setState({newPolicy: !this.state.newPolicy});
  };

  render() {
    return (
      <Container>
        <Card style={{ borderRadius: '10px', boxShadow: '0 14px 30px -2px #00000021', border: 'none'}}>
                  <Card.Header
            className='text-center'
            style={{
              fontSize: '28px',
              // color: 'white',
              backgroundColor: '#e9e9ff',
              fontWeight:'bold',
              borderRadius: '10px 10px 0 0',
            }}
          >
            Policy Lookup
          </Card.Header>
          <Card.Body>
            <Form noValidate={true} onSubmit={this.handleSubmit} validated={this.state.validated}>
              <Row>
                <Col xs={12} sm={true}>
                  <Form.Group
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '10px',marginTop: '10px'}}
                  >
                    <Form.Control
                      aria-label='Policy Number'
                      type='text'
                      value={this.props.policyNumber}
                      onChange={this.props.onChange}
                      disabled={this.props.isFeinNumber}
                      placeholder='Policy Number'
                      id='policyNumber'
                      style={{ display: 'inline-block'}}
                    />
                    <TooltipButton />
                  </Form.Group>
                </Col>
              </Row>
              <Row className='d-flex justify-content-center align-items-center'>
                <Form.Group>
                  <Col xs={12} style={{textAlign: 'center'}}>
                    <span>OR</span>
                  </Col>
                </Form.Group>
              </Row>
              <Row>
                <Col xs={12} sm={true}>
                  <Form.Group
                    style={{ display: 'flex', alignItems: 'center', marginBottom: '10px',marginTop: '10px'}}
                  >
                    <Form.Control
                      aria-label='FEIN Number'
                      type='text'
                      value={this.props.feinNumber}
                      onChange={this.props.onChange}
                      disabled={this.props.isPolicyNumber}
                      placeholder='FEIN Number'
                      id='finNumber'
                      style={{
                        display: 'inline-block'}}
                    />
                    <TooltipButton isFein={true}/>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={true}>
                  <Form.Check style={{textAlign: 'right'}}>
                    <Form.Check.Input onClick={() => this.handleNewPolicy()}/>
                    <Form.Check.Label>New Policy or Monthly Reporting Deposit?</Form.Check.Label>
                  </Form.Check>
                </Col>
              </Row>
              {!this.state.newPolicy ?
                (
                  <Button
                    variant='primary'
                    type='submit'
                    disabled={this.props.loading || (this.props.policyNumber === '' && this.props.feinNumber === '')}
                    className='mt-3'
                  >
                    {this.props.loading ? <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                    /> : 'Submit'}
                  </Button>
                )
              :
                (
                  <Link
                    to={{
                      pathname: '/pay-now'
                    }}
                  >
{<Button variant='primary'>Continue To Payment</Button> as any}
                  </Link>
                )
              }
            </Form>
          </Card.Body>
        </Card>
      </Container>
    );
  }
}

export default SearchForm;
